import { theme } from 'antd'
import { ThemeCommon } from './theme.common'
import { ThemeType } from './theme.config'
import { ThemeConst } from './theme.const'

export const ThemeConsumer: ThemeType = {
  algorithm: theme.defaultAlgorithm,
  token: {
    ...ThemeCommon.token,
    colorPrimary: '#000000',
    controlItemBgActive: '#efeff0',
    controlItemBgActiveHover: '#efeff0',
  },
  components: {
    Layout: {
      headerBg: 'white',
      headerPadding: 0,
    },
    Menu: {
      itemBg: ThemeConst.CONSUMER_LIGHTGREY,
      itemSelectedBg: 'white',
      itemActiveBg: 'white',
      itemHoverBg: 'white',
    },
    Select: {
      optionSelectedBg: ThemeConst.CONSUMER_LIGHTGREY,
    },
    Collapse: {
      contentBg: 'white',
      contentPadding: 4,
      headerBg: 'white',
      headerPadding: 4,
      colorBorder: '#e5e7eb',
    },
    Progress: {
      defaultColor: '#000000',
    },
    Button: {
      primaryShadow: 'none',
    },
    Dropdown: {
      controlItemBgActive: 'transparent',
      controlItemBgActiveHover: 'lightgrey',
    },
    Table: {
      headerBg: 'white',
      headerColor: 'grey',
    },
  },
}
